import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const DirectionContext = createContext({
  direction: 'ltr',
  setDirection: () => {},
});

export function DirectionProvider({ children }) {
  const [direction, setDirection] = useState('ltr');
  const currentLanguage = useSelector((state) => state?.translation?.language);
  
  // Sync HTML lang attribute when Redux language changes
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const activeLang = currentLanguage || localStorage.getItem('userLanguage') || 'en';
      document.documentElement.lang = activeLang;
      document.documentElement.setAttribute('lang', activeLang);
    }
  }, [currentLanguage]);

  // Update document direction when context changes
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const activeLang = currentLanguage || localStorage.getItem('userLanguage') || 'en';
      document.documentElement.lang = activeLang;
      document.documentElement.setAttribute('lang', activeLang);
      document.documentElement.dir = direction;
      document.documentElement.setAttribute('dir', direction);
      document.body.setAttribute('dir', direction);
      
      // Apply a class to the body for additional styling hooks
      if (direction === 'rtl') {
        document.body.classList.add('rtl-direction');
        document.body.classList.remove('ltr-direction');
      } else {
        document.body.classList.add('ltr-direction');
        document.body.classList.remove('rtl-direction');
      }
      
      // Force re-layout with a more reliable approach
      const currentScroll = window.scrollY;
      document.body.style.opacity = '0.99';
      setTimeout(() => {
        document.body.style.opacity = '1';
        // Restore scroll position
        window.scrollTo(0, currentScroll);
      }, 50);
    }
  }, [direction, currentLanguage]);
  
  // Initialize from localStorage on mount
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const userLanguage = localStorage.getItem('userLanguage') || 'en';
      document.documentElement.lang = userLanguage;
      document.documentElement.setAttribute('lang', userLanguage);
      const isRTL = ['ar'].includes(userLanguage);
      setDirection(isRTL ? 'rtl' : 'ltr');
    }
  }, []);
  
  return (
    <DirectionContext.Provider value={{ direction, setDirection }}>
      {children}
    </DirectionContext.Provider>
  );
}

export function useDir() {
  return useContext(DirectionContext);
}
